<style lang="less" scoped>
ul li {
  list-style: none;
}
.list {
  position: fixed;
  top: 36px;
  width: 90px;
  z-index: 999;
  background: #13227a;
  right: 0;
  box-sizing: border-box;
  li {
    text-align: center;
    margin: 0 5px;
    height: 23px;
    // width: 90px;
    line-height: 23px;

    border-bottom: 0.04167rem dashed #ffffff96;
    a {
      font-size: 10px;
      display: inherit;
      color: #fff;
    }
  }
  li:last-child {
    border-bottom: none !important;
  }
}
.menu {
  position: absolute;
  right: 7.08333rem;

  min-width: 90px;
  max-width: 120px;
  bottom: 0px;
  background: #13227a;
}
</style>
<template>
  <div class="list">
    <ul>
      <li>
        <a @click="handle_home">{{ $t("header.home1") }}</a>
      </li>
      <li>
        <a @click="queryData('v3_article_data')">{{
          $t("keywords.keywords14")
        }}</a>
      </li>
      <li>
        <a @click="queryData('v3_scientific_data')">{{ $t("header.home2") }}</a>
      </li>
      <li>
        <a @click="queryData('v3_dissertation_data')">{{
          $t("header.home33")
        }}</a>
      </li>
      <li>
        <a @click="queryData('v3_patent_data')">{{ $t("header.home28") }}</a>
      </li>
      <li @click="showMenu">
        <a>{{ $t("result.content18") }}</a>
      </li>
      <ul class="menu" v-show="showData">
        <li>
          <a @click="handle_member">{{ $t("header.home6") }}</a>
        </li>
        <li>
          <a
            v-if="lang != 'en'"
            href="https://www.cstr.cn/search/openApi/"
            target="_blank"
            >OPEN API</a
          >
          <a
            v-else
            href="https://www.cstr.cn/en/search/openApi/"
            target="_blank"
            >OPEN API</a
          >
        </li>

        <li>
          <a @click="handle_prefix">{{ $t("header.home32") }}</a>
        </li>
        <li>
          <a @click="handle_guide">{{ $t("guide.guide20") }}</a>
        </li>
      </ul>
      <li>
        <a @click="handle_news">{{ $t("header.home16") }}</a>
      </li>
      <li>
        <a @click="handle_about">{{ $t("header.home7") }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import $ from "jquery";
import lang from "../lang/en";
export default {
  data() {
    return {
      showData: false,
      i: 0,
      lang: "",
    };
  },
  mounted() {
    // var router = this.$route.fullPath;
    // if (router.indexOf("/en") != -1) {
    //   this.$cookie.set("lang", "en", {
    //     expires: "1h",
    //   });
    // } else {
    //   this.$cookie.set("lang", "zh", {
    //     expires: "1h",
    //   });

    this.lang = this.$cookie.get("lang");
  },
  methods: {
    showMenu() {
      this.i += 1;
      if (this.i % 2 == 1) {
        this.showData = true;
      } else {
        this.showData = false;
      }

      //  if(this.i%2==0){
      //   this.showData=true
      // this.i+1
      //  }else{
      //   this.showData =false
      //  }
    },
    handle_home() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Main",
        });
      } else {
        this.$router.push({
          name: "EnMain",
        });
      }
      // this.$router.push({
      //   name: "Main",
      // });
    },
    queryData(val) {
      if (this.lang == "en") {
        location.href = "/phone/en/search/search?params=" + val;
      } else {
        location.href = "/phone/search/search?params=" + val;
      }
    },

    handle_member() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Member",
        });
      } else {
        this.$router.push({
          name: "enMember",
        });
      }
    },
    handle_cold() {
      if (this.lang != "en") {
        this.$router.push({
          name: "ServiceList",
        });
      } else {
        this.$router.push({
          name: "ServiceEnList",
        });
      }
    },
    handle_order() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Project",
        });
      } else {
        this.$router.push({
          name: "EnProject",
        });
      }
    },
    handle_project(val) {
      if (this.lang != "en") {
        this.$router.push({
          name: "NsfList",
        });
      } else {
        this.$router.push({
          name: "NsfEnList",
        });
      }
    },
    handle_guide() {
      if (this.lang != "en") {
        this.$router.push({
          name: "guide",
        });
      } else {
        this.$router.push({
          name: "guideEn",
        });
      }
    },
    handle_about() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Intro",
        });
      } else {
        this.$router.push({
          name: "IntroEn",
        });
      }
    },

    handle_news() {
      if (this.lang != "en") {
        this.$router.push({
          name: "NewList",
        });
      } else {
        this.$router.push({
          path: "/en/search/news/works",
        });
      }
    },
    handle_prefix() {
      if (this.lang != "en") {
        this.$router.push({
          name: "Prefix",
        });
      } else {
        this.$router.push({
          name: "EnPrefix",
        });
      }
    },
  },
};
</script>